export default __webpack_public_path__ + "static/media/beko_text.93da6326.svg";